import httpClient from './httpClient';
import { Tenant, TenantFormData, TenantUpdateData } from '../types/tenant';

// Obtener todos los tenants
export const getAllTenants = async (): Promise<Tenant[]> => {
    const response = await httpClient.get<Tenant[]>('/api/admin/tenants');
    return response.data;
};

// Obtener un tenant específico
export const getTenant = async (tenantId: string): Promise<Tenant> => {
    const response = await httpClient.get<Tenant>(`/api/admin/tenants/${tenantId}`);
    return response.data;
};

// Crear un nuevo tenant
export const createTenant = async (tenantData: TenantFormData) => {
    const response = await httpClient.post('/api/admin/tenants', tenantData);
    return response.data;
};

// Actualizar un tenant
export const updateTenant = async (tenantId: string, updateData: TenantUpdateData) => {
    const response = await httpClient.put(`/api/admin/tenants/${tenantId}`, updateData);
    return response.data;
};

// Eliminar un tenant
export const deleteTenant = async (tenantId: string) => {
    const response = await httpClient.delete(`/api/admin/tenants/${tenantId}`);
    return response.data;
};

// Obtener el tenant actual del usuario autenticado
export const getCurrentTenant = async (): Promise<Tenant> => {
    const response = await httpClient.get<Tenant>('/api/tenant/current');
    return response.data;
};

// SERVICIOS DE LICENCIAS

// Renovar licencia de un tenant
export const renovarLicencia = async (tenantId: string, tipo: '3_meses' | '6_meses' | '1_año', usuario?: string) => {
    const response = await httpClient.post(`/api/admin/tenants/${tenantId}/licencia/renovar`, {
        tipo,
        usuario
    });
    return response.data;
};

// Suspender licencia de un tenant
export const suspenderLicencia = async (tenantId: string, usuario?: string, observaciones?: string) => {
    const response = await httpClient.post(`/api/admin/tenants/${tenantId}/licencia/suspender`, {
        usuario,
        observaciones
    });
    return response.data;
};

// Verificar licencia de un tenant
export const verificarLicencia = async (tenantId: string) => {
    const response = await httpClient.get(`/api/admin/tenants/${tenantId}/licencia/verificar`);
    return response.data;
};

// Obtener estadísticas de licencias
export const getEstadisticasLicencias = async () => {
    const response = await httpClient.get('/api/admin/tenants/licencias/estadisticas');
    return response.data;
};

// Obtener tenants por vencer
export const getTenantsPorVencer = async (dias: number = 30) => {
    const response = await httpClient.get(`/api/admin/tenants/licencias/por-vencer?dias=${dias}`);
    return response.data;
};

// Procesar notificaciones de vencimiento
export const procesarNotificaciones = async () => {
    const response = await httpClient.post('/api/admin/tenants/licencias/procesar-notificaciones');
    return response.data;
};

// Verificar licencias vencidas
export const verificarLicenciasVencidas = async () => {
    const response = await httpClient.post('/api/admin/tenants/licencias/verificar-vencidas');
    return response.data;
};